<template>
    <Card :bordered="false" class="border-radius-0">
        <Row :gutter="24">
            <Col :xs="24" :md="24">
                <CardBorder :title="$t('views.report.labPhysic.resultByDepartment.search')">
                    <CTable v-if="state && state.columns.length > 0"
                            :visibleTable="false"
                            :visiblePagination="false"
                            :canRefresh="false"
                            :isLoading="isLoading"
                            v-model:columns="state.columns"
                            v-model:page="state.page"
                            :options="state.tableOptions"
                            :rowActions="state.rowActions"
                            @search="(search) => onSearch({ ...search, props, data })"
                    ></CTable>
                </CardBorder>
            </Col>
        </Row>
        <Row :gutter="24">
            <Col :xs="24" :md="12">
                <CardBorder :title="$t('views.report.labPhysic.resultByDepartment.passResult')">
                    <CTable
                            :isLoading="data.isLoadingDeptProductType"
                            v-model:columns="data.acceptColumns"
                            v-model:page="data.pageDeptProductType"
                            :options="data.tableOptions"
                            :manages="data.manages"
                            :visibleSearch="false"
                            :clientSide="true"
                            :canRefresh="false"
                    ></CTable>
                </CardBorder>
            </Col>
            <Col :xs="24" :md="12">
                <CardBorder :title="$t('views.report.labPhysic.resultByDepartment.rejectResult')">
                    <CTable
                            :isLoading="data.isLoadingDeptProductType"
                            v-model:columns="data.rejectColumns"
                            v-model:page="data.pageDeptProductType"
                            :options="data.tableOptions"
                            :manages="data.manages"
                            :visibleSearch="false"
                            :clientSide="true"
                            :canRefresh="false"
                    ></CTable>
                </CardBorder>
            </Col>
        </Row>
        <Row :gutter="24" v-if="state.initData">
            <Col v-for="record in state.initData?.productTypes" v-bind:key="record.id">
                <CardBorder :title="$t('views.report.labPhysic.resultByDepartment.rejectResult') + ` (${record.valueEn || ''}) `">
                    <CTable
                            :isLoading="data.isLoadingDeptProdutTypeLabTopic"
                            v-model:columns="data[`columnLabTopics`]"
                            v-model:page="data[`page${record.valueEn}`] "
                            :options="data.tableOptions"
                            :manages="data.manages"
                            :visibleSearch="false"
                            :clientSide="true"
                            :canRefresh="false"
                    ></CTable>
                </CardBorder>
            </Col>
        </Row>
    </Card>
</template>

<script>

    import { Card, Row, Col } from 'ant-design-vue';
    import { defineAsyncComponent, defineComponent, reactive } from 'vue';
    import { state as stateApp } from '../../../../../../app.logic';
    import { initState, isLoading, onSearch, state } from './result-by-department-report.logic';
    import { createPage } from '../../../../../../utils/page';

    export default defineComponent({
        components: {
            Row,
            Col,
            Card,
            CTable: defineAsyncComponent(() => import('../../../../../../components/table/CTable')),
            CardBorder: defineAsyncComponent(() => import('../../../../../../components/card/CardBorder'))
        },
        props: {
            menuContext: { default: () => stateApp.menuContext },
            refLabTypeKey: { default: 'labPhysic' },
            refSamplingRequestTypeKey: { }
        },
        setup(props) {
            const data = reactive({
                isLoadingDeptProductType: false,
                columnProductTypes: [],
                columnLabTopics: [],
                pageDeptProductType: createPage({}),
                pageCanned: createPage({}),
                pageFrozen: createPage({}),
                pageChilled: createPage({}),
                pageTraditional: createPage({}),
                pageOther: createPage({}),
            });
            initState({ props, data });
            return {
                props, isLoading, state, onSearch, data
            };
        }
    });
</script>
